import type { TippyConfig } from '@/core/features/tooltip/tooltip';

import React from 'react';

import { IconImage, Tooltip, TooltipTextBox } from '@/core/features';

type CheckoutCancellationDesktopProps = {
    fontSize?: 'font-size-12' | 'font-size-14';
    iconUrl: string;
    overlayHtmlText?: string;
    overlayHtmlTitle?: string;
    text: string;
    textColor: string;
    tippyConfig?: TippyConfig;
};

export default function CheckoutCancellationInfoDesktop({
    fontSize = 'font-size-12',
    iconUrl,
    overlayHtmlText,
    overlayHtmlTitle,
    text,
    textColor,
    tippyConfig,
}: CheckoutCancellationDesktopProps) {
    if (overlayHtmlText && overlayHtmlTitle) {
        return (
            <Tooltip
                ariaLabel={overlayHtmlTitle}
                className={'width-fit-content'}
                content={
                    <TooltipTextBox
                        fontWeightTitle={'bold'}
                        htmlText={overlayHtmlText}
                        htmlTitle={overlayHtmlTitle}
                    />
                }
                tippyConfig={{
                    offset: [0, 10],
                    placement: 'left',
                    ...tippyConfig,
                }}
            >
                <CancellationText
                    fontSize={fontSize}
                    iconUrl={iconUrl}
                    text={text}
                    textColor={textColor}
                />
            </Tooltip>
        );
    }

    return (
        <CancellationText
            fontSize={fontSize}
            iconUrl={iconUrl}
            text={text}
            textColor={textColor}
        />
    );
}

function CancellationText({
    fontSize,
    iconUrl,
    text,
    textColor,
}: Pick<CheckoutCancellationDesktopProps, 'fontSize' | 'iconUrl' | 'text' | 'textColor'>) {
    return (
        <div
            className={`flex gap-5 line-height-14 ${fontSize}`}
            style={{ color: textColor }}
        >
            <IconImage
                className={'shrink-0'}
                height={14}
                url={iconUrl}
                width={14}
            />
            {text}
        </div>
    );
}
